import { Table, Tag, Space, Button, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const SubscriptionPlansTable = ({ plans, loading, onEdit, onDeactivate }) => {
    const columns = [
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            render: (name, record) => (
                <Space>
                    <span>{name}</span>
                    {record.is_default && <Tag color="blue">Default</Tag>}
                </Space>
            ),
        },
        {
            title: "Slug",
            dataIndex: "slug",
            key: "slug",
        },
        {
            title: "Price",
            key: "price",
            render: (_, record) =>
                record.amount === 0
                    ? "Free"
                    : `${record.currency || "USD"} ${Number(record.amount).toFixed(2)}`,
        },
        {
            title: "Interval",
            dataIndex: "billing_interval",
            key: "billing_interval",
            render: (v) => (v === "year" ? "Annual" : "Monthly"),
        },
        {
            title: "LLM Quota",
            dataIndex: "general_quota_limit",
            key: "general_quota_limit",
        },
        {
            title: "Polars Limit",
            key: "polars_summary_quota_limit",
            render: (_, record) =>
                record.amount > 0
                    ? "Unlimited"
                    : record.polars_summary_quota_limit ?? "Default",
        },
        {
            title: "Features",
            key: "features",
            render: (_, record) => (record.features || []).length,
        },
        {
            title: "Status",
            dataIndex: "active",
            key: "active",
            render: (active) =>
                active ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>,
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <Space>
                    <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => onEdit(record)}
                    >
                        Edit
                    </Button>
                    <Popconfirm
                        title="Deactivate this plan?"
                        onConfirm={() => onDeactivate(record)}
                        okText="Yes"
                        cancelText="No"
                        disabled={!record.active}
                    >
                        <Button type="link" danger icon={<DeleteOutlined />} disabled={!record.active}>
                            Deactivate
                        </Button>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={plans}
            loading={loading}
            pagination={{ pageSize: 10 }}
            rowKey={(record) => record._id || record.key}
        />
    );
};

export default SubscriptionPlansTable;
